var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleJobsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83333 3.16667C9.83333 1.90933 9.83333 1.28133 9.44267 0.890667C9.052 0.5 8.424 0.5 7.16667 0.5C5.90933 0.5 5.28133 0.5 4.89067 0.890667C4.5 1.28133 4.5 1.90933 4.5 3.16667M0.5 8.5C0.5 5.986 0.5 4.72867 1.28133 3.948C2.06267 3.16733 3.31933 3.16667 5.83333 3.16667H8.5C11.014 3.16667 12.2713 3.16667 13.052 3.948C13.8327 4.72933 13.8333 5.986 13.8333 8.5C13.8333 11.014 13.8333 12.2713 13.052 13.052C12.2707 13.8327 11.014 13.8333 8.5 13.8333H5.83333C3.31933 13.8333 2.062 13.8333 1.28133 13.052C0.500667 12.2707 0.5 11.014 0.5 8.5Z",
    stroke: "#534BDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleJobsIcon);
export default __webpack_public_path__ + "static/media/purple-jobs-icon.76d9635f4c76b27edf3253d4a70c3343.svg";
export { ForwardRef as ReactComponent };